// 🏋️‍♀️ Personal Trainer Packages (Experience-Based Levels)
export const personalTrainerPackages = {
  // "Essential": {
  //   description:
  //     "💪 Our *Essential Trainers* are certified fitness professionals with **less than 1 year of personal training experience**. They’re energetic, passionate, and perfect for beginners who need motivation, consistency, and guidance to start right. Ideal for those building strength, mobility, and confidence in their fitness journey.",
  //   packages: [
  //     {
  //       id: "essential-30",
  //       packageName: "30 Sessions Personal Training",
  //       totalServices: 30,
  //       perSessionPrice: 89,
  //       packageDurationUnit: "Month",
  //       packageDuration: 5,
  //       perServiceTime: 1,
  //       recommended: true,
  //       objective: "cardio improvement",
  //     },
  //     {
  //       id: "essential-24",
  //       packageName: "24 Sessions Personal Training",
  //       totalServices: 24,
  //       perSessionPrice: 94,
  //       packageDurationUnit: "Month",
  //       packageDuration: 4,
  //       perServiceTime: 1,
  //       objective: "mobility & stamina",
  //     },
  //     {
  //       id: "essential-50",
  //       packageName: "50 Sessions Personal Training",
  //       totalServices: 50,
  //       perSessionPrice: 86,
  //       packageDurationUnit: "Month",
  //       packageDuration: 7,
  //       perServiceTime: 1,
  //       objective: "weight loss, muscle building",
  //     },
  //     {
  //       id: "essential-14",
  //       packageName: "14 Sessions Personal Training",
  //       totalServices: 14,
  //       perSessionPrice: 99,
  //       packageDurationUnit: "Month",
  //       packageDuration: 2,
  //       perServiceTime: 1,
  //       objective: "fitness starter",
  //     }
  //   ]
  // },

  "Signature": {
    description:
      "⚡ Our *Signature Trainers* have **over 2 years of professional experience** and proven track records helping clients achieve visible results. They specialize in strength training, endurance, and progressive transformation programs. Best suited for individuals who already exercise but want expert guidance to push past plateaus and level up their performance.",
    packages: [
      {
        id: "signature-30",
        packageName: "30 Sessions Personal Training",
        totalServices: 30,
        perSessionPrice: 89,
        packageDurationUnit: "Month",
        packageDuration: 5,
        perServiceTime: 1,
        recommended: true,
        objective: "toning & performance",
      },
      {
        id: "signature-24",
        packageName: "24 Sessions Personal Training",
        totalServices: 24,
        perSessionPrice: 92,
        packageDurationUnit: "Month",
        packageDuration: 4,
        perServiceTime: 1,
        objective: "strength & endurance",
      },
      {
        id: "signature-14",
        packageName: "14 Sessions Personal Training",
        totalServices: 14,
        perSessionPrice: 99,
        packageDurationUnit: "Month",
        packageDuration: 2,
        perServiceTime: 1,
        objective: "fitness progression",
      },
      {
        id: "signature-50",
        packageName: "50 Sessions Personal Training",
        totalServices: 50,
        perSessionPrice: 84,
        packageDurationUnit: "Month",
        packageDuration: 7,
        perServiceTime: 1,
        objective: "lean muscle & strength",
      }
    ]
  },

  "Elite": {
    description:
      "🔥 Our *Elite Trainers* are highly qualified professionals with **more than 5 years of experience** training clients across all fitness levels — from general fitness to competitive athletes. They deliver customized, high-performance programs focused on precision, body sculpting, and peak conditioning. Ideal for those serious about achieving the best version of themselves.",
    packages: [
      {
        id: "elite-30",
        packageName: "30 Sessions Personal Training",
        totalServices: 30,
        perSessionPrice: 99,
        packageDurationUnit: "Month",
        packageDuration: 5,
        perServiceTime: 1,        
        recommended: true,
        objective: "strength optimization",
      },
      {
        id: "elite-24",
        packageName: "24 Sessions Personal Training",
        totalServices: 24,
        perSessionPrice: 104,
        packageDurationUnit: "Month",
        packageDuration: 4,
        perServiceTime: 1,
        objective: "high performance & agility",
      },
      {
        id: "elite-14",
        packageName: "14 Sessions Personal Training",
        totalServices: 14,
        perSessionPrice: 110,
        packageDurationUnit: "Month",
        packageDuration: 2,
        perServiceTime: 1,
        objective: "intensive conditioning",
      },
      {
        id: "elite-50",
        packageName: "50 Sessions Personal Training",
        totalServices: 50,
        perSessionPrice: 95,
        packageDurationUnit: "Month",
        packageDuration: 7,
        perServiceTime: 1,
        objective: "performance mastery",
      }
    ]
  },
};

// 🔁 Generate Buddy Packages from Personal Training Packages
export const generateBuddyPackages = (
    basePackages,
    multiplier = 0.7, // 70% of solo price per pax
    label = "Per Pax"
  ) => {
    const result = {};

    Object.keys(basePackages).forEach((tier) => {
      const tierData = basePackages[tier];

      result[tier] = {
        ...tierData,
        description: tierData.description.replace(
          "Personal Training",
          "Buddy Training"
        ),
        packages: tierData.packages.map((pkg) => ({
          ...pkg,
          id: `buddy-${pkg.id}`,
          packageName: pkg.packageName.replace(
            "Personal Training",
            `Buddy Training (${label})`
          ),
          perSessionPrice: Math.round(pkg.perSessionPrice * multiplier),
        })),
      };
    });

    return result;
};
// 🌍 UAE / Malaysia packages
//
// Same tiers, session counts, durations and buddy multiplier as Singapore -
// only the per-session price changes, in local currency (AED / MYR). Priced
// ~25-40% under the going home-PT rate in Dubai/Abu Dhabi and KL for fast
// market entry (see the expansion plan for the market references).
//
// The SG table above stays the default export shape; SG callers that import
// `personalTrainerPackages` directly are unaffected.
const MARKET_PER_SESSION_PRICES = {
  ae: {
    Signature: { 14: 199, 24: 189, 30: 179, 50: 169 },
    Elite: { 14: 225, 24: 212, 30: 199, 50: 189 },
  },
  my: {
    Signature: { 14: 149, 24: 139, 30: 129, 50: 119 },
    Elite: { 14: 169, 24: 159, 30: 149, 50: 139 },
  },
};

const buildMarketPackages = (prices) =>
  Object.fromEntries(
    Object.entries(personalTrainerPackages).map(([tier, tierData]) => [
      tier,
      {
        ...tierData,
        packages: tierData.packages.map((pkg) => ({
          ...pkg,
          perSessionPrice: prices[tier][pkg.totalServices],
        })),
      },
    ])
  );

export const marketPersonalTrainerPackages = {
  ae: buildMarketPackages(MARKET_PER_SESSION_PRICES.ae),
  my: buildMarketPackages(MARKET_PER_SESSION_PRICES.my),
};

export const getPersonalTrainerPackages = (countryCd) =>
  marketPersonalTrainerPackages[(countryCd || "sg").toLowerCase()] ?? personalTrainerPackages;
